/**
 * Builds Chakra toast props after runCalcWithAutoFundingFix, or null when no notice is needed.
 */
export function buildAutoFixFeedback(autoFix) {
  if (!autoFix?.attempted) {
    return null;
  }

  const monthLabel =
    autoFix.changeCount === 1 ? '1 month' : `${autoFix.changeCount} months`;

  if (autoFix.applied && autoFix.fullyFixed) {
    return {
      title: 'Funding adjusted for covenant limits',
      description: `Calculate adjusted funding in ${monthLabel} so results meet the active limits.`,
      status: 'info',
      duration: 6000,
      isClosable: true,
    };
  }

  const firstIssue = autoFix.firstRemainingViolation;
  if (!firstIssue) {
    return null;
  }

  if (autoFix.applied) {
    return {
      title: 'Partial funding adjustment',
      description: `Calculate adjusted funding in ${monthLabel}, but could not fix all limit breaches. First remaining issue: ${firstIssue}`,
      status: 'warning',
      duration: 9000,
      isClosable: true,
    };
  }

  return {
    title: 'Could not adjust funding automatically',
    description: `The plan breaches covenant limits and could not be fixed by adjusting funding alone. First issue: ${firstIssue}`,
    status: 'warning',
    duration: 9000,
    isClosable: true,
  };
}
